
import React, { useState } from 'react';






import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {
    Row,
    Col,
  } from "reactstrap";


import deviationIcon from '../../assets/img/deviation.svg'




const DeviationHelpModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;
  
  const [modal, setModal] = useState(false);
  

  const toggle = () => setModal(!modal);
  console.log(props.deviat)
  return (
    <div>
      <i onClick={toggle} className="now-ui-icons media-2_sound-wave" style={{color:'rgb(255,200,100)',cursor:'pointer'}}/> <span className={props.colorForm}>--</span>
      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Deviation</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">
            <Row style={{padding:'10px'}}> 
                <h3 className='text-warning'>Feedback</h3>         
                <p className={feedbackMessage(props.deviat)[1]}>{feedbackMessage(props.deviat)[0]}</p>
            </Row>
            <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
            </Row>
            <Row style={{padding:'10px'}}>     
                <h3 className='text-warning'>Help</h3>      
                <p className='text-white'>The average value of activities stress score for the last 45 days is calculated. Then the app calculates the deviation of the values from the average one. A well structured program will produce small values of deviation therefore small injury risks as the mileage and stress build up is gradual. A poor structured program will produce a high deviation value due to inconsistencies from day to day training. It is adviced to keep this value as low as possible</p>
                <img alt="" src={deviationIcon} className="icons" style={{height:"90px",width:'190px',fill:'white'}}/>
               
            </Row>
          </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <Button color="danger" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

function feedbackMessage(deviation){
    var message = "Need more Data. Train more and come back later for feedback"
    if (deviation<=0.1){
        message = 'Need more Data. Train more and come back later for feedback'
        return [message,'text-warning']
      }
    if (deviation<=1){
      message = 'Excellent work your training habits are very consistent.'
      return [message,'text-success']
    }
    if (deviation<=3){
        message = 'Your training habits consistent.'
        return [message,'text-info']
    }
    if (deviation<=5){
        message = 'Your training habits are not consistent. Consider following a more structured program. Injury risk is moderate'
        return [message,'text-warning']
    }
    if (deviation<=10){
        message = 'Unstructured training program.Your day to day training habits are extremely inconsistent. Injury risk is high'
        return [message,'text-danger']
    }
    if (deviation>10){
        message = 'Unstructured training program.Your day to day training habits are extremely inconsistent. Injury risk is critical high'
        return [message,'text-danger']
    }
    return [message,'text-warning']
}
export default DeviationHelpModal;